export const RAFFLE_ROUTE = "/promos/:id";

export const getRafflePath = (raffleId: number): string =>
  `/promos/${raffleId}`;

// Id приходит из адресной строки: там может быть что угодно.
export const parseRaffleId = (param: string | undefined): number | null => {
  if (!param || !/^\d+$/.test(param)) return null;
  const id = Number(param);
  return id > 0 && Number.isSafeInteger(id) ? id : null;
};
